import { Pipe, PipeTransform } from '@angular/core';

/**
 * Checks whether a string or boolean is true.
 * Returns false, when value is null or undefined.
 */
@Pipe({
  name: 'safeCheck',
  standalone: true,
})
export class SafeCheckPipe implements PipeTransform {
  transform(value: boolean | string | undefined): boolean {
    if (value === undefined || value === null) {
      return false;
    }
    return value.toString() === 'true';
  }
}
